import { AuthLevel, generateApiPath } from '@guiker/shared-framework'

const paths = {
  rentPaymentsPlan: generateApiPath({ prefix: AuthLevel.AUTH, name: 'rent-payments-plan' }),
  tenantInstalment: generateApiPath({ prefix: AuthLevel.AUTH, name: 'tenant-instalment' }),
}

export { paths }
